/**
 * ============================================================================
 * useKbBacklinks — Lista paginada de artigos que referenciam a página atual.
 *                  Consulta kb_page_links via RPC segura (nunca varre JSON).
 *
 * CHANGELOG:
 *   RELEASE: 2026-07-08 v1.0.0 - Versão inicial.
 * ============================================================================
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";

export interface KbBacklink {
  source_page_id: string;
  source_title: string;
  source_slug: string;
  source_status: string;
  space_id: string;
  space_name: string;
  collection_name: string | null;
  anchor: string | null;
  updated_at: string;
  total_count: number;
}

export function useKbBacklinks(pageId?: string | null, page = 0, pageSize = 20) {
  return useQuery({
    queryKey: ["kb", "backlinks", pageId ?? null, page, pageSize],
    enabled: !!pageId,
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("kb_get_page_backlinks", {
        p_page_id: pageId!,
        p_limit: pageSize,
        p_offset: page * pageSize,
        p_tenant_hint: null,
      });
      if (error) {
        logger.error("[useKbBacklinks]", "falha ao buscar backlinks", error);
        throw error;
      }
      const rows = (data ?? []) as KbBacklink[];
      return {
        rows,
        total: rows[0]?.total_count ?? 0,
      };
    },
  });
}
